import Lesson from '../../../api/Lesson';
import * as types from './mutation-types';

export const store = async ({commit}, {params}) => {
    const json = await new Lesson().store(params);

    commit(types.LESSON, json);
};

export const show = async ({commit}, {id}) => {
    const json = await new Lesson().show(id);

    commit(types.LESSON, json.data);
};

export const update = async (context, {id, params}) => {
    await new Lesson().update(id, params);
};

export const updateLessonStatus = async (context, {id, params}) => {
    await new Lesson().updateLessonStatus(id, params)
};

export const destroy = async (context, {id}) => {
    await new Lesson().destroy(id)
};

export const getAll = async ({commit}) => {
    const json = await new Lesson().getAll();

    commit(types.LESSONS, json);
};

export const trackProgress = async (context, { id, params }) => {
    return await new Lesson().trackProgress(id, params)
};

export const duplicate = async ({commit}, {id, params}) => {
    const json = await new Lesson().duplicate(id, params);
    return json.id;
};

export default {
    store,
    show,
    update,
    updateLessonStatus,
    destroy,
    getAll,
    trackProgress,
    duplicate,
};



// WEBPACK FOOTER //
// ./src/store/modules/lesson/actions.js